import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const fallbackLng = ['es'];
const availableLanguages = ['es', 'ca', 'en', 'eu'];

i18n
    .use(Backend) // load translations using http (default public/assets/locals/en/translations)
    .use(LanguageDetector) // detect user language
    .use(initReactI18next) // pass the i18n instance to react-i18next.
    .init({
        fallbackLng, // fallback language is spanish.

        detection: {
            checkWhitelist: true, // options for language detection
        },

        debug: false,

        whitelist: availableLanguages,

        ns: ['translation'],
        defaultNS: 'translation',

        interpolation: {
            escapeValue: false, // no need for react. it escapes by default
        },

        backend: {
            loadPath: process.env.REACT_APP_UTILS + '/locale?lang={{lng}}',
            crossDomain: true,
        }

    });

const t = i18n.t.bind(i18n);
export { t, i18n };